import Toastify from 'toastify-js';

export const handleToast = (status, text, duration = 5000) => {
    Toastify({
        node: (() => {
            const div = document.createElement('div');
            div.innerHTML = text;
            return div;
        })(),
        className: status,
        stopOnFocus: true,
        duration: duration,
        close: false,
        gravity: 'bottom',
    }).showToast();
};
